const DEFAULT_API = ''

export function getEnv() {
  const raw = import.meta.env.VITE_API_BASE_URL as string | undefined
  const trimmed = raw?.trim()
  const apiBaseUrl = (trimmed && trimmed.length > 0 ? trimmed : DEFAULT_API).replace(/\/$/, '')
  return {
    mode: import.meta.env.MODE,
    isDev: import.meta.env.DEV,
    apiBaseUrl,
  }
}
